import type { IAreaBoundary } from '@/shared/api/types/destination-types'

export interface DestinationDraftFormValue {
  countryId: string
  provinceId: string
  slug: string
  destinationType: string
  areaBoundary: IAreaBoundary | null
  centerPoint: [number, number] | null
  banner: string
  thumbnail: string
  isActive: boolean
}

export interface DestinationDraftTranslationValue {
  language: string
  title: string
  name: string
  description: string
}

export interface PersistedDestinationDraft {
  form: DestinationDraftFormValue
  translations: DestinationDraftTranslationValue[]
}

export interface BuildDestinationDraftInput {
  form: DestinationDraftFormValue
  translations: DestinationDraftTranslationValue[]
}

export function buildDestinationDraft(
  input: BuildDestinationDraftInput,
): PersistedDestinationDraft {
  return {
    form: input.form,
    translations: input.translations,
  }
}

export function hasDestinationDraftContent(
  input: BuildDestinationDraftInput,
  defaultForm: DestinationDraftFormValue,
): boolean {
  const formChanged = JSON.stringify(input.form) !== JSON.stringify(defaultForm)
  const hasTranslationContent = input.translations.some(
    (row) => (row.title ?? '').trim() || (row.name ?? '').trim() || (row.description ?? '').trim(),
  )
  return formChanged || hasTranslationContent
}
